module.exports = __webpack_public_path__ + "static/media/toilet.22b9dd3b.svg";